import { render, staticRenderFns } from "./OrdersFBMShowSection.vue?vue&type=template&id=031f6f41&scoped=true"
import script from "./OrdersFBMShowSection.vue?vue&type=script&lang=js"
export * from "./OrdersFBMShowSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031f6f41",
  null
  
)

export default component.exports